import React, { useState } from "react";
import PropTypes from "prop-types";
import Box from "@mui/system/Box";
import Typography from "@mui/material/Typography";
import StyledModal from "../../../Modals/StyledModal/StyledModal";
import { formatTitleCase } from "../../../../utils/formatHelpers";
import TertiaryButton from "../../../Buttons/TertiaryButton/TertiaryButton";

export default function LoadProfileRouteInfoModal({
  city,
  state,
  hoursOperation,
  referenceNumbers,
  stopNotes
}) {
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Box>
      <TertiaryButton
        onClick={handleOpen}
        label="More Stop Info"
        color="primary.60"
      />
      <StyledModal
        label={`${formatTitleCase(city)}, ${state}`}
        title={`${formatTitleCase(city)}, ${state}`}
        open={open}
        handleClose={handleClose}
      >
        <Box sx={{ maxWidth: "500px", maxHeight: "600px", overflowY: "auto" }}>
          {hoursOperation.length < 1 && referenceNumbers.length < 1 && stopNotes.length < 1 &&
            <Typography variant="body1" color="black_opacity.100">No additional information</Typography>
          }
          {hoursOperation.length > 0 &&
            <Box marginBottom="20px">
              <Typography
                variant="subhead1"
                color="black_opacity.100"
              >
                Hours of Operation
              </Typography>
              <span className="Load-route-info-value">
                <Typography
                  variant="body1"
                  color="black_opacity.100"
                >
                  {hoursOperation.map(h => (
                    <Box key={`hours-operation-${h.id}`}>
                      <Typography
                        variant="body1"
                        color="black_opacity.100"
                      >
                        {h.day} {h.time}
                      </Typography>
                    </Box>
                  ))}
                </Typography>
              </span>
            </Box>
          }
          {referenceNumbers.length > 0 &&
            <Box marginBottom="20px">
              {referenceNumbers.map(r => (
                <Box key={`reference-number-${r.id}`}>
                  <Typography
                    variant="subhead1"
                    color="black_opacity.100"
                  >
                    {r.reference_qual} Number
                  </Typography>
                  <span className="Load-route-info-value">
                    <Typography
                      variant="body1"
                      color="black_opacity.100"
                    >
                      {r.reference_number}
                    </Typography>
                  </span>
                </Box>
              ))}
            </Box>
          }
          {stopNotes.length > 0 &&
            <Box>
              <Typography
                variant="subhead1"
                color="black_opacity.100"
              >
                Rate Con Comments
              </Typography>
              {stopNotes.map(r => (
                <span key={`comment-${r.id}`} className="Load-route-info-value">
                  <Typography
                    variant="body1"
                    color="black_opacity.100"
                  >
                    {r.comments}
                  </Typography>
                  <br />
                </span>
              ))}
            </Box>
          }
        </Box>
      </StyledModal>
    </Box>
  );
}

LoadProfileRouteInfoModal.propTypes = {
  city: PropTypes.string,
  state: PropTypes.string,
  hoursOperation: PropTypes.array.isRequired,
  referenceNumbers: PropTypes.array.isRequired,
  stopNotes: PropTypes.array.isRequired
};